<div *ngFor="let asset of modules" class="p-1">
    <module-card [module]="asset" [showProgress]="showProgress"></module-card>
</div>